import React from "react";
import styles from "../styles/experience.module.css";

const Experience = () => {
  return (
    <div className={styles.experience}>
      <h1>
        <span style={{ color: "#3ABFF8" }}>💡</span> Experience
      </h1>
      <div style={{ display: "flex" }}>
        <div
          className={styles.stepper}
          style={{
            display: "flex",
            flexDirection: "column",
            marginRight: "1rem",
            marginTop: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: "1rem",
                width: "1rem",
                border: "2px solid white",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>
            <div
              className={styles.stepperHeightOne}
              style={{
                height: "30.7rem",
                width: "1px",
                backgroundColor: "#b3c5efb0",
              }}
            ></div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: "1rem",
                width: "1rem",
                border: "2px solid white",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>
            <div
              className={styles.stepperHeightOne}
              style={{
                height: "22.5rem",
                width: "1px",
                backgroundColor: "#b3c5efb0",
              }}
            ></div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: "1rem",
                width: "1rem",
                borderRadius: "50%",
                border: "2px solid white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>
            <div
              style={{
                height: "14rem",
                width: "1px",
                backgroundColor: "#b3c5efb0",
              }}
            ></div>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
          <div className={styles.firstExp}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <p
                className={styles.duration}
                style={{ fontSize: "1.5rem", color: "#b3c5ef" }}
              >
                SDE-I Fullstack
              </p>
              <p
                className={styles.duration}
                style={{ fontSize: "1.2rem", color: "#b3c5efcc" }}
              >
                VideoVerse July 2024 - Present
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontSize: "1.3rem",
                marginTop: "1.2rem",
              }}
              className={styles.expDesc}
            >
              <p>
                • Built a publishing module and rule engine to automate secure
                content distribution to cloud, social media, CMS, and other
                platforms, reducing manual effort by 90%.
              </p>
              <p>
                • Redesigned the legacy configuration module to streamline
                content tagging, RBAC, and entity management across the
                platform, improving operational efficiency by 40%.
              </p>
              <p>
                • Built an internal utility library to standardize and share
                code across multiple services, published via GitHub Packages.
              </p>
              <p>
                • Developed backend services using NestJS, TypeScript, AWS and
                PostgreSQL, supporting migration to microservices architecture.
              </p>
              <p>
                • Took end-to-end ownership of the frontend codebase, resolving
                90% of on-call tickets within SLA.
              </p>
              <p>
                • Integrated Playwright in the frontend codebase to automate E2E
                testing, increasing test coverage and reducing regressions.
              </p>
              <p>
                • Tech Stack : React, Redux, TypeScript, PostgreSQL, NestJS,
                AWS, Ant Design, MongoDB, Node.js
              </p>
            </div>
          </div>

          <div className={styles.firstExp}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <p
                className={styles.duration}
                style={{ fontSize: "1.5rem", color: "#b3c5ef" }}
              >
                Frontend Engineer Intern
              </p>
              <p
                className={styles.duration}
                style={{ fontSize: "1.2rem", color: "#b3c5efcc" }}
              >
                VELT (YCW22) October 2023 - February 2024
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontSize: "1.3rem",
                marginTop: "1.2rem",
              }}
              className={styles.expDesc}
            >
              <p>
                • Implemented a new onboarding flow, resulting in a 90%
                reduction in user effort and driving a 50% increase in the user
                base.
              </p>
              <p>
                • Optimized and refactored the frontend codebase, leading to
                improved reusability, scalability, and faster load times.
              </p>
              <p>
                • Implemented key features such as custom branding and feature
                gating, resulting in a 20% increase in MRR.
              </p>
              <p>• Converted 50% of the vanilla CSS code to Tailwind CSS.</p>
              <p>
                • Tech Stack : Angular, TypeScript, Firebase, RxJS, Angular
                Material UI
              </p>
            </div>
          </div>

          <div className={styles.expDesc}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <p
                className={styles.duration}
                style={{ fontSize: "1.5rem", color: "#b3c5ef" }}
              >
                Frontend Developer Intern
              </p>
              <p
                className={styles.duration}
                style={{ fontSize: "1.2rem", color: "#b3c5efcc" }}
              >
                TEXTIFY AI April 2023 - August 2023
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontSize: "1.3rem",
                marginTop: "1.2rem",
              }}
            >
              <p>
                • Developed a personalized job recommendation system, automating
                the generation of resumes, interview questions, cold emails, and
                cover letters tailored to specific jobs.
              </p>
              <p>
                • Implemented key features and revamped the UI of the Textify.ai
                website, resulting in an 80% increase in new users.
              </p>
              <p>• Tech Stack : React.js, Next.js, JavaScript, Material UI</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
